import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { ColumnConfigEx, ColumnDefinitionEx } from "../../../../@core/types/column-config-types-extended";
import { applySearchRule } from '../../../../@core/utils/search-input-helper';
import { Address, DiscountGroupVendorRelation, DiscountGroupVendorRelationSearchInput, Operator } from "../../../../generated/generated-types";
import { BaseListWrapperComponent } from '../../../../shared/components/base-list-wrapper/base-list-wrapper.component';
import { NewBaseListComponent } from "../../../../shared/components/new-base-list-component/new-base-list-component";
import { AddressDropDownComponent } from "../../../crm/modules/company-drop-down/company-drop-down/address-drop-down.component";
import { DiscountGroupVendorRelationService } from "../../services/discount-group-vendor-relation.service";

@Component({
  selector: 'app-discount-group-vendor-relation-widget',
  template: `<app-base-list-wrapper [baseListComponent]="this" />`,
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    BaseListWrapperComponent,
  ]
})
export class DiscountGroupVendorRelationWidgetComponent extends NewBaseListComponent<DiscountGroupVendorRelation> {

  discountGroupId = input<string>();

  constructor(
    discountGroupVendorRelationService: DiscountGroupVendorRelationService,
  ) {
    super("DiscountGroupVendorRelation", discountGroupVendorRelationService);

    this.addInDetail = false;
    this.noCopy = true;
    this.noBaseEdit = true;
    this.inlineEditMode = true;
  }

  override getSearchInputForQuery(): DiscountGroupVendorRelationSearchInput {
    let si: DiscountGroupVendorRelationSearchInput = super.getSearchInputForQuery();

    applySearchRule(si, {
      field: "discountGroupId",
      operator: Operator.equal,
      value: this.discountGroupId()
    });

    return si;
  }

  protected override setColumnConfig(colConfig: ColumnConfigEx): void {
    let col: ColumnDefinitionEx = colConfig.columns.find(x => x.field === 'vendor.name' || (x.prop === "name" && x.entityType === 'Address'));
    if (col) {
      col.getEditComponent = () => AddressDropDownComponent;
      col.editComponentCreated = async (c: AddressDropDownComponent, rowData: any, _colDef: ColumnDefinitionEx) => {
        if (rowData?.vendor)
          c.setModel(rowData.vendor);
        else if (rowData?.vendorId) {
          await c.loadItemByIdAndSetSelected(rowData.vendorId);
          this.cdRef.detectChanges();
        }

        c.value.subscribe((x) => {
          rowData.vendorId = (x as Address)?.id;
        });
      }
    }

    super.setColumnConfig(colConfig);
  }

  override saveInCRUDService(rowData: DiscountGroupVendorRelation): Promise<DiscountGroupVendorRelation> {
    return super.saveInCRUDService({ ...rowData, discountGroupId: this.discountGroupId() });
  }

}
